module.exports = __webpack_public_path__ + "img/list2.10092be9.png";